import {  useState } from 'react';
import { ActionIcon, Tooltip } from '@mantine/core';
import { VideoContentDisplay } from './VideoContentDisplay';
import { TOOLTIPS } from '../../../resource/tooltipTexts';
import { IconPlayerPlayFilled } from '@tabler/icons-react';
import { useVideoAttachmentActions } from '../../../resource/resources/artifacts/attachment/videoAttachmentResource';

export const LazyVideoContentDisplay= ({videoAttachmentObjectId, versionedIn, height}: {
    videoAttachmentObjectId: string;
    versionedIn: string;
    height: number | null
}) => {
    const videoAttachmentActions = useVideoAttachmentActions()
    const videoAttachmentQuery = videoAttachmentActions.useGetResourceByObjectIdAndVersionedIn(videoAttachmentObjectId, versionedIn)

    const [playbackRequested, setPlaybackRequested] = useState<boolean>(false);

    if (playbackRequested) {
        if (videoAttachmentQuery.data?.id) {
            return <VideoContentDisplay height={height ?? undefined}
                                        videoAttachmentId={videoAttachmentQuery.data.id} />
        } else {
            return <div>No video content could have been found!</div>
        }
    } else {
        return <div style={{height: height ?? undefined, width: "100%", backgroundColor: "grey", display: "flex", justifyContent: "center", alignItems: "center"}}>
            <Tooltip label={TOOLTIPS.LOAD_VIDEO}>
                <ActionIcon
                    disabled={false}

                    size={'lg'}
                    onClick={() => setPlaybackRequested(true)}
                    style={{ padding: '6px', backgroundColor: 'inherit' , transform: "scale(3)" }}
                    variant={'transparent'}
                    color={'var(--mantine-color-base-button)'}
                >
                    {<IconPlayerPlayFilled/>}
                </ActionIcon>
            </Tooltip>

        </div>
    }
};
